import React from 'react';
import { IconButton, Stack, Tooltip } from "@mui/material";
import { TooltipName } from "../../../../../utils/Enums";
import gridActiveIcon from "../../../../../styles/svg/grid-view-active.svg";
import gridInactiveIcon from "../../../../../styles/svg/grid-view-inactive.svg";
import listActiveIcon from "../../../../../styles/svg/list-view-active.svg";
import listInactiveIcon from "../../../../../styles/svg/list-view-inactive.svg";
import { useBoardViewToggle } from "./hooks/useBoardViewToggle";

const ViewToggle = ({ setLoading, setParamsWorklogs, searchParams, setSearchParams }) => {
  const { handleGridClick, handleListClick, isGridActive, isListActive } =
    useBoardViewToggle({
      searchParams,
      setSearchParams,
      setParamsWorklogs,
      setLoading,
    });

  return (
    <Stack className="grid-list-cont">
      <Tooltip title={TooltipName.KANBAN_VIEW}>
        <IconButton
          aria-label="grid-view"
          className="board-header-grid-icon"
        >
          <img
            src={isGridActive ? gridActiveIcon : gridInactiveIcon}
            alt="gridIcon"
            onClick={handleGridClick}
          />
        </IconButton>
      </Tooltip>
      <Tooltip title={TooltipName.LIST_VIEW}>
        <IconButton
          aria-label="list-view"
          className="board-header-list-icon"
          sx={{ borderLeft: "1px solid rgba(145, 158, 171, 0.2)" }}
        >
          <img
            src={isListActive ? listActiveIcon : listInactiveIcon}
            alt="listIcon"
            onClick={handleListClick}
          />
        </IconButton>
      </Tooltip>
    </Stack>
  );
};

export default ViewToggle; 
